export const SHADOWS = {
  PAGE: '0px 4px 8px 0px rgba(22, 22, 22, 0.06), 0px 0px 1px 0px rgba(22, 22, 22, 0.12)',
  CARD: '0px 0px 1px rgba(22, 22, 22, 0.12), 0px 4px 8px rgba(22, 22, 22, 0.06)',
};
